export default {
  mounted(el, binding) {
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let initialX = 0;
    let initialY = 0;

    // 判断是否为移动设备
    const isTouchDevice = 'ontouchstart' in window;

    // 设置元素样式
    el.style.position = 'fixed';
    el.style.cursor = 'move';
    el.style.userSelect = 'none';
    el.style.touchAction = 'none';

    // 处理开始拖拽
    const startDrag = (clientX, clientY) => {
      isDragging = false;
      startX = clientX;
      startY = clientY;

      // 获取当前元素位置
      const rect = el.getBoundingClientRect();
      initialX = rect.left;
      initialY = rect.top;

      // 添加拖拽中样式
      el.classList.add('dragging-active');
    };

    // 处理拖拽移动
    const onDrag = (clientX, clientY) => {
      if (!isDragging) {
        // 判断是否真的开始拖拽（移动超过阈值）
        const dx = Math.abs(clientX - startX);
        const dy = Math.abs(clientY - startY);
        if (dx > 5 || dy > 5) {
          isDragging = true;
        } else {
          return;
        }
      }

      // 计算新位置
      let newX = initialX + (clientX - startX);
      let newY = initialY + (clientY - startY);

      // 边界检查
      const maxX = window.innerWidth - el.offsetWidth;
      const maxY = window.innerHeight - el.offsetHeight;

      newX = Math.max(0, Math.min(newX, maxX));
      newY = Math.max(0, Math.min(newY, maxY));

      // 应用新位置
      el.style.left = `${newX}px`;
      el.style.top = `${newY}px`;
    };

    // 处理结束拖拽
    const endDrag = () => {
      el.classList.remove('dragging-active');

      // 如果是点击而非拖拽，触发点击事件
      if (!isDragging && binding.value?.onClick) {
        binding.value.onClick();
      }

      isDragging = false;
    };

    // 鼠标事件处理
    const handleMouseDown = (e) => {
      startDrag(e.clientX, e.clientY);
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseMove = (e) => {
      onDrag(e.clientX, e.clientY);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      endDrag();
    };

    // 触摸事件处理
    const handleTouchStart = (e) => {
      startDrag(e.touches[0].clientX, e.touches[0].clientY);
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      document.addEventListener('touchend', handleTouchEnd);
    };

    const handleTouchMove = (e) => {
      e.preventDefault();
      onDrag(e.touches[0].clientX, e.touches[0].clientY);
    };

    const handleTouchEnd = () => {
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
      endDrag();
    };

    // 添加事件监听器
    if (isTouchDevice) {
      el.addEventListener('touchstart', handleTouchStart);
    } else {
      el.addEventListener('mousedown', handleMouseDown);
    }

    // 保存清理函数
    el._cleanupDraggable = () => {
      if (isTouchDevice) {
        el.removeEventListener('touchstart', handleTouchStart);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
      } else {
        el.removeEventListener('mousedown', handleMouseDown);
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      }
    };
  },

  unmounted(el) {
    // 清理事件监听器
    if (el._cleanupDraggable) {
      el._cleanupDraggable();
    }
  },
};
